<template>
  <div class="card" v-if="schedule.profissionais.length > 0" data-cy="agenda-main-card">
    <div
      class="card-header text-center text-md-left py-1 calendar-available-color font-weight-bold text-white"
      data-cy="agenda-main-header"
    >
      {{ schedule.label }}
    </div>

    <agenda-geral-profissional
      :reschedule="reschedule"
      v-for="profissional in schedule.profissionais"
      :key="profissional.id"
      :profissional="profissional"
      :data-cy="`agenda-main-profissional-${profissional.id}`"
    ></agenda-geral-profissional>
  </div>
</template>

<script>
import AgendaGeralProfissional from "./agenda-geral-profissional";

export default {
  name: "agenda-geral-main",
  props: ["schedule", "reschedule"],
  components: {
    AgendaGeralProfissional
  }
};
</script>

<style>
.accordion > .card:last-of-type {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom: 2px solid rgba(0, 0, 0, 0.125);
}
</style>
